import { ReadonlyURLSearchParams } from 'next/navigation';

import { getCookie } from './cookies.util';

export const getCouponAndAffiliate = (
  searchParams: ReadonlyURLSearchParams
) => {
  const coupon = searchParams.get('coupon') || undefined;

  const affiliate = getCookie('affiliate');
  const source = getCookie('source');

  return {
    coupon,
    affiliate: affiliate ?? source,
  };
};
